import {
	downloadDataBoxMessageQuery,
	useAxiosInstance,
	useDownloadPoMutation,
} from '@gov-nx/api';
import type { OnMessageSaveParams } from '@gov-nx/component/common';

export interface MessageDownloadProps {
	onError: (messageId: number, error: Error) => void;
	onSuccess: (data: OnMessageSaveParams) => void;
}

export const useMessageDownload = (props: MessageDownloadProps) => {
	const { axiosInstance } = useAxiosInstance();

	return useDownloadPoMutation(downloadDataBoxMessageQuery(axiosInstance), {
		onError: (error, messageData) =>
			props.onError(messageData.message.datovaZpravaId as number, error),
		onSuccess: async (data) =>
			props.onSuccess({
				antivirus: data.antivirus,
				fileName: data.fileName,
				blob: data.blob,
				id: data.variables.message.datovaZpravaId as number,
			}),
	});
};
